import React from 'react';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <div className="terms-content">
        <h1>Terms of Service</h1>
        <p>Last updated: May 5, 2025</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using this website, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our website.</p>
        </section>

        <section>
          <h2>2. Use of Website</h2>
          <p>This website is intended for informational purposes about our engineering and automation services. You agree to use this website only for lawful purposes and in accordance with these Terms.</p>
        </section>

        <section>
          <h2>3. Intellectual Property</h2>
          <p>All content on this website, including but not limited to text, graphics, logos, and images, is the property of Project Power By CW and is protected by intellectual property laws.</p>
        </section>

        <section>
          <h2>4. Disclaimer</h2>
          <p>The information provided on this website is for general informational purposes only. We make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the website or the information, products, services, or related graphics contained on the website.</p>
        </section>

        <section>
          <h2>5. Limitation of Liability</h2>
          <p>Project Power By CW shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use this website.</p>
        </section>

        <section>
          <h2>6. Links to Third-Party Websites</h2>
          <p>Our website may contain links to third-party websites. We have no control over the content, privacy policies, or practices of these websites and accept no responsibility for them.</p>
        </section>

        <section>
          <h2>7. Changes to Terms</h2>
          <p>We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to the website.</p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>These Terms shall be governed by and construed in accordance with the laws of Malaysia.</p>
        </section>

        <section>
          <h2>9. Contact Information</h2>
          <p>For any questions regarding these Terms of Service, please contact us at:</p>
          <p>Email: sales@projectpowerbycw.com</p>
          <p>Phone: +60 16-286 5881</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService; 